export const LABELS = {
  client: {
    singular: 'person',
    singularCapitalized: 'Person',
    plural: 'people',
    pluralCapitalized: 'People',
    tabLabel: 'People',
    addButton: 'Add someone',
    addTitle: 'Add someone to your account',
    emptyState: 'No one added to your account yet',
    addFirstPrompt: 'Add Your First Person',
    removeConfirm: 'Remove this person from your account?',
    activity: 'Activity',
  },
  caregiver: {
    singular: 'caregiver',
    singularCapitalized: 'Caregiver',
    plural: 'caregivers',
    pluralCapitalized: 'Caregivers',
  },
  self: {
    activityTab: 'Your Activity',
    messagesTab: 'Your Messages',
  }
};
export default LABELS;
